import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=88dd7baa&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./electron-scss/index.scss?vue&type=style&index=0&id=88dd7baa&prod&lang=scss&scoped=true&external"
import style1 from "./Index.vue?vue&type=style&index=1&id=88dd7baa&prod&lang=scss&scoped=true"
import style2 from "./Index.vue?vue&type=style&index=2&id=88dd7baa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_underscore@1.13.7_vue-t_t2nkcq7z6p7kqveyao2fqanapi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dd7baa",
  null
  
)

export default component.exports